import {
  useDataOriginalValue,
  useDataIsSubmitting,
  useDataValue,
} from 'Simple/Data.js'
import isEqual from 'lodash/isEqual.js'

export function useIsDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'comms_settings',
    viewPath: props.viewPath,
  })
  let value = useDataValue({
    viewPath: props.viewPath,
    context: 'comms_settings',
  })

  let original_value = useDataOriginalValue({
    viewPath: props.viewPath,
    context: 'comms_settings',
  })

  return (
    value.flags.length === 0 ||
    value.from === null ||
    value.to === 0 ||
    value.allowed_days.length === 0 ||
    isEqual(value, original_value) ||
    isSubmitting
  )
}
